/**
 * Mckay-brothers Portal
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import {Inject, Injectable, Optional} from '@angular/core';
import {HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpResponse} from '@angular/common/http';
import {CustomHttpUrlEncodingCodec} from '../encoder';

import {Observable} from 'rxjs';

import {BASE_PATH} from '../variables';
import {Configuration} from '../configuration';
import {Company} from '../../models/company';


@Injectable()
export class CompanyService {

  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();
  protected basePath = 'https://localhost';

  constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  /**
   * Removes the Company resource.
   *
   * @param id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteCompanyItem(id: string, observe?: 'body', reportProgress?: boolean): Observable<any>;

  public deleteCompanyItem(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;

  public deleteCompanyItem(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;

  public deleteCompanyItem(id: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling deleteCompanyItem.');
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [];

    return this.httpClient.delete<any>(`${this.basePath}/api/companies/${encodeURIComponent(String(id))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Retrieves the collection of Company resources.
   *
   * @param uniqid
   * @param uniqid2
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getCompanyCollection(uniqid?: string, uniqid2?: Array<string>, observe?: 'body', reportProgress?: boolean): Observable<Array<Company>>;

  public getCompanyCollection(uniqid?: string, uniqid2?: Array<string>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Company>>>;

  public getCompanyCollection(uniqid?: string, uniqid2?: Array<string>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Company>>>;

  public getCompanyCollection(uniqid?: string, uniqid2?: Array<string>, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

    let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (uniqid !== undefined) {
      queryParameters = queryParameters.set('uniqid', <any>uniqid);
    }
    if (uniqid2) {
      uniqid2.forEach((element) => {
        queryParameters = queryParameters.append('uniqid[]', <any>element);
      });
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [];

    return this.httpClient.get<Array<Company>>(`${this.basePath}/api/companies`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Endpoint not implemented!
   *
   * @param uniqid
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getCompanyItem(uniqid: string, observe?: 'body', reportProgress?: boolean): Observable<Company>;

  public getCompanyItem(uniqid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Company>>;

  public getCompanyItem(uniqid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Company>>;

  public getCompanyItem(uniqid: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
    if (uniqid === null || uniqid === undefined) {
      throw new Error('Required parameter id was null or undefined when calling getCompanyItem.');
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [];

    return this.httpClient.get<Company>(`${this.basePath}/api/companies?uniqid=${encodeURIComponent(String(uniqid))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Creates a Company resource.
   *
   * @param company The new Company resource
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public postCompanyCollection(company, observe?: 'body', reportProgress?: boolean): Observable<Company>;

  public postCompanyCollection(company, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Company>>;

  public postCompanyCollection(company, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Company>>;

  public postCompanyCollection(company, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [
      'application/json'
    ];
    let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.post<Company>(`${this.basePath}/api/companies`,
      company,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Replaces the Company resource.
   *
   * @param id
   * @param company The updated Company resource
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public putCompanyItem(id: string, company, observe?: 'body', reportProgress?: boolean): Observable<Company>;

  public putCompanyItem(id: string, company, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Company>>;

  public putCompanyItem(id: string, company, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Company>>;

  public putCompanyItem(id: string, company, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling putCompanyItem.');
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [
      'application/json'
    ];
    let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.put<Company>(`${this.basePath}/api/companies/${encodeURIComponent(String(id))}`,
      company,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  activateClient(clientId) {
    return this.httpClient.put(this.basePath + '/api/company/' + clientId + '/activate', null);
  }

  deactivateClient(clientId) {
    return this.httpClient.put(this.basePath + '/api/company/' + clientId + '/deactivate', null);
  }

  /**
   * @param consumes string[] mime-types
   * @return true: consumes contains 'multipart/form-data', false: otherwise
   */
  private canConsumeForm(consumes: string[]): boolean {
    const form = 'multipart/form-data';
    for (let consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }
}
